// Mock data for Rajiv Syndicate Group clone (frontend-only)

export const IMAGES = {
  warehouseShelves1: "https://images.unsplash.com/photo-1644079446600-219068676743?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  warehouseShelves2: "https://images.unsplash.com/photo-1601598704991-eef6114775e0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  warehouseAisle: "https://images.pexels.com/photos/38195854/pexels-photo-38195854.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  warehouseWorker: "https://images.unsplash.com/photo-1664382953403-fc1ac77073a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  warehouseWorker2: "https://images.pexels.com/photos/4483865/pexels-photo-4483865.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  battery: "https://images.pexels.com/photos/32282232/pexels-photo-32282232.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  brake: "https://images.pexels.com/photos/833320/pexels-photo-833320.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  engine: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  camshaft: "https://images.pexels.com/photos/29226618/pexels-photo-29226618.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  workshop: "https://images.unsplash.com/photo-1767681092416-bccf9410bda4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "History", to: "/history" },
  { label: "Services", to: "/services" },
  { label: "Locations", to: "/locations" },
  { label: "Gallery", to: "/gallery" },
  { label: "Newspaper", to: "/newspaper" },
  { label: "Career", to: "/career" },
];

export const STATS = [
  { value: 1996, label: "Founded as a car-parts retail shop", isYear: true },
  { value: 15, label: "Retail outlets across North Haryana", suffix: "" },
  { value: 3, label: "OEM authorisations held", suffix: "" },
  { value: 4, label: "Firms in the Group today", suffix: "" },
];

export const OEM_PARTNERS = [
  {
    since: "Since 2008",
    name: "Maruti Suzuki",
    desc: "Grew from a single Ambala warehouse to three warehouses — Ambala, Yamuna Nagar and Sonipat — and 11 retail outlets across North Haryana.",
    items: ["Genuine Parts", "Genuine Accessories", "Genuine Oil"],
  },
  {
    since: "Since 2010",
    name: "Amaron Batteries",
    desc: "Distributed from two warehouses covering Panipat and Sonipat districts, serving passenger and commercial vehicle fleets alike.",
    items: ["Car & LCV Batteries", "HCV & Bike Batteries", "Inverter & HUPS"],
  },
  {
    since: "Since 2013",
    name: "Hero MotoCorp Genuine Parts",
    desc: "Operates today as Super Stockiest, covering the entire northern half of Haryana for two-wheeler parts, accessories and consumables.",
    items: ["Genuine Parts", "Genuine Accessories", "Genuine Oil", "Genuine Batteries"],
  },
];

export const WHY_CHOOSE = [
  "Three decades of warehouse and retail experience, from a single Ambala Cantt shop to four operating firms today.",
  "Strategically located warehouses across Ambala, Yamuna Nagar, Sonipat and Panipat keep genuine parts moving without gaps.",
  "Authorised distributorships with Maruti Suzuki, Amaron and Hero MotoCorp mean genuine stock, never aftermarket substitutes.",
];

export const TOWNS = [
  "Ambala Cantt", "Ambala City", "Kurukshetra", "Karnal", "Shahbad",
  "Barara", "Pehowa", "Panipat", "Sonipat", "Yamuna Nagar", "Kaithal",
];

export const DISTRICTS = [
  "Ambala", "Kurukshetra", "Karnal", "Yamuna Nagar", "Kaithal", "Panipat", "Sonipat",
];

export const HISTORY_TIMELINE = [
  { year: "1996", title: "A car-parts retail shop opens in Ambala Cantt", body: "Rajiv Syndicate Group enters the automobile parts business as a single retail counter, selling car parts directly to customers in Ambala." },
  { year: "2000s", title: "Retail expands into wholesale", body: "After a decade of retail trading, the Group upgrades into wholesale distribution — the first step toward becoming an Authorised Parts Distributor rather than a shopfront seller." },
  { year: "2008", title: "Authorised Distributor for Maruti Suzuki Genuine Parts", body: "Appointed distributor for Maruti Suzuki Genuine Parts across northern Haryana. What began as one warehouse in Ambala grows to three — Ambala, Yamuna Nagar and Sonipat — feeding 11 retail outlets." },
  { year: "2010", title: "Amaron Batteries distribution begins", body: "The Group takes on Amaron Batteries for Panipat and Sonipat districts, running two dedicated warehouses to supply car, commercial-vehicle and two-wheeler batteries." },
  { year: "2013", title: "Hero MotoCorp Genuine Parts Distribution", body: "Rajiv Syndicate takes on Hero MotoCorp Genuine Parts distribution and, over time, grows into Super Stockiest — now covering the entire northern half of Haryana." },
  { year: "Today", title: "Four firms, one group", body: "The business now operates under four firms — Rajiv Syndicate AutoZone Pvt Ltd., Rajiv Syndicate, Rajiv Motors and Ambala Syndicate — led by Directors Sanjay Jain and Rajiv Jain." },
];

export const FIRMS = [
  "Rajiv Syndicate AutoZone Pvt Ltd.",
  "Rajiv Syndicate",
  "Rajiv Motors",
  "Ambala Syndicate",
];

export const DIRECTORS = [
  {
    name: "Sanjay Jain", role: "Director, Rajiv Syndicate Group",
    note: "Accepted the Hero MotoCorp Best Distributor Award (2022–23) on the Group's behalf at the National Parts Distributors Conference in Malaysia.",
    initials: "SJ",
    email: "ambalasyndicate@gmail.com",
    phone: "+91-9215926605",
    linkedin: "https://www.linkedin.com/in/sanjay-jain-45856817/",
  },
  {
    name: "Rajiv Jain", role: "Director, Rajiv Syndicate Group",
    note: "The Group's founding namesake, overseeing the warehouse and retail network across Northern Haryana.",
    initials: "RJ",
    email: null,
    phone: null,
    linkedin: null,
  },
];

export const AWARD_CATEGORIES = [
  { title: "Best Warehouse", body: "Recognising warehouse inventory management discipline across Ambala, Yamuna Nagar, Sonipat and Panipat." },
  { title: "Best Technology User", body: "Recognising the application of modern inventory-tracking technology across three OEM lines." },
  { title: "Maximum Sales Growth", body: "Recognising sustained sales growth since taking on each distributorship." },
];

export const SERVICES = [
  {
    id: "maruti", since: "Authorised since 2008", title: "Maruti Suzuki Genuine Parts, Accessories & Oil",
    desc: "Distributed across North Haryana from three dedicated warehouses — Ambala, Yamuna Nagar and Sonipat — feeding 11 retail outlets. Warehouse inventory is managed to keep genuine Maruti Suzuki stock moving without gaps in territory coverage.",
    items: ["Maruti Suzuki Genuine Parts", "Maruti Suzuki Genuine Accessories", "Maruti Suzuki Genuine Oil"],
    metaLabel: "Warehouses", meta: ["Ambala", "Yamuna Nagar", "Sonipat"], image: IMAGES.warehouseShelves1,
  },
  {
    id: "hero", since: "Authorised since 2013", title: "Hero MotoCorp Genuine Parts, Accessories & Oil",
    desc: "Grew into Super Stockiest status, now covering the entire northern half of Haryana for two-wheeler genuine parts, consumables and accessories.",
    items: ["Hero MotoCorp Genuine Parts", "Hero MotoCorp Genuine Accessories", "Hero MotoCorp Genuine Oil"],
    metaLabel: "Coverage", meta: ["Super Stockiest — northern half of Haryana"], image: IMAGES.engine,
  },
  {
    id: "amaron", since: "Authorised since 2010", title: "Amaron Batteries — Car, LCV, HCV, Bike, Inverter & HUPS",
    desc: "Distributed from two warehouses across Panipat and Sonipat districts, covering battery needs from passenger cars through to home backup power.",
    items: ["Car Batteries", "LCV & HCV Batteries", "Bike Batteries", "Inverter & HUPS Batteries"],
    metaLabel: "Warehouses", meta: ["Panipat", "Sonipat"], image: IMAGES.battery,
  },
];

export const WORK_PRINCIPLES = [
  { title: "Allocated territory", body: "Each warehouse serves a defined set of towns, avoiding overlap and stockouts." },
  { title: "Warehouse inventory management", body: "Technology-led stock tracking across all three OEM lines." },
  { title: "Trained retail staff", body: "Regular skill upgrades to serve retail outlets and end customers better." },
];

export const GALLERY = [
  { image: IMAGES.warehouseWorker, tag: "Recognition · 2022–23", title: "Best Distributor Award (Hero MotoCorp)", caption: "Sanjay Jain receives the award from Mr. Akhilesh Vijay, National Head Parts, at the National Parts Distributors Conference, 2022–23." },
  { image: IMAGES.warehouseAisle, tag: "Culture", title: "On the warehouse floor", caption: "A look at the everyday discipline the Group's founding family carries into its warehouses." },
  { image: IMAGES.brake, tag: "Product", title: "Maruti Suzuki Genuine Brake Parts", caption: "A look at the genuine components that move through our Maruti Suzuki warehouse network daily." },
  { image: IMAGES.battery, tag: "Product", title: "Amaron Battery Range", caption: "Car, LCV, HCV, bike and inverter batteries distributed across Panipat and Sonipat." },
  { image: IMAGES.warehouseShelves2, tag: "Operations", title: "Organised inventory", caption: "Technology-led stock tracking keeps genuine parts moving without gaps." },
  { image: IMAGES.camshaft, tag: "Product", title: "Genuine engine components", caption: "Precision genuine parts — never aftermarket substitutes." },
];

export const CAREER_AREAS = [
  { title: "Warehouse Operations", body: "Inventory handling, stock management, dispatch across our Ambala, Yamuna Nagar, Sonipat and Panipat warehouses." },
  { title: "Retail Counter", body: "Customer-facing sales staff across our 15+ retail outlets." },
  { title: "Logistics & Drivers", body: "Moving genuine parts between warehouses and outlets on schedule." },
  { title: "Accounts", body: "Billing, reconciliation and reporting across four operating firms." },
];

export const JOB_ROLES = [
  "General Application — no specific opening yet",
  "Warehouse Operations", "Retail Counter", "Logistics & Drivers", "Accounts",
];

export const CONTACT_INFO = {
  address: ["Kuldeep Nagar, GT Road,", "Ambala Cantt, Haryana"],
  accounts: ["92159 26601", "92159 26645"],
  accountsEmail: "rajiv.wh.acnt@gmail.com",
  feedback: ["92159 26605", "92159 26607"],
  feedbackEmail: "ambalasyndicate@gmail.com",
  general: "rajiv.wh.ambala@gmail.com",
  social: {
    linkedin: "https://www.linkedin.com/company/rajiv-syndicate-autozone-private-limited",
    facebook: "https://www.facebook.com/RajivSyndicateAutozonePvtLtd",
  },
};
